import { Config } from 'utils';
import moment from 'moment/src/moment';

class App {

	resourceUrl(name) {

		//TODO: "hack", za dohvatiti pozadinsku sliku, zamijeniti sa backgroundURL parametrom
		var map = {
			'back.svg': '/images/back.svg',
			'logo.png': '/images/vv-logo.png',
			'job-board-arrow.svg': '/images/job-board-arrow.svg',
			'close.svg': '/images/close.svg',
			'close-white.svg': '/images/close-white.svg',
			'vdkz-logo.png': '/images/vdkz-logo.png',
			'whyus/benefits.svg': '/images/whyus/benefits.svg',
			'whyus/perks.svg': '/images/whyus/perks.svg',
			'whyus/testimonials.svg': '/images/whyus/testimonials.svg',
			'hackathon-menu-icon.svg': '/images/hackathon-menu-icon.svg',
			'briefcase.svg': '/images/briefcase.svg',
			'calendar.svg': '/images/calendar.svg',
			'clipboard.svg': '/images/clipboard.svg',
			'questionmark.svg': '/images/questionmark.svg',
			'stopwatch.svg': '/images/stopwatch.svg'
		}

		if(map[name]) {
			return map[name];
		} else {
			return Config.resourceBaseUrl + name;
		}
	}

	url(val) {
		return 'url(' + val + ')';
	}

	pavilionUrl(pavilion) {
		return '/pavilion/' + pavilion.slug + '/stand/first';
	}

	standUrl(pavilion, stand) {
		return '/pavilion/' + pavilion + '/stand/' + stand;
	}

	activityUrl(pavilion, stand, type) {
		return this.standUrl(pavilion.slug, stand.slug) + '/' + type;
	}

	formatShortDate(date) {
		return moment(date, 'YYYY-MM-DD').format(Config.format.date.short);
	}

	filename(url) {
		var xp = /.*\/(.*?)\./;
		return xp.exec(url)[1];
	}

	setPageTitle(val) {
		document.title = val;
		$('#ogtitle').attr('content', val);
	}
}

const app = new App();
export default app;


// WEBPACK FOOTER //
// ./src/modules/model/app.js